import React from "react"
import './404.css'
import {Box, Grid} from "@material-ui/core";
const NotFoundView = () => {
  return (
    <Grid container alignItems={"flex-end"}>
      <Grid item sm={1}/>
      <Grid item sm={3} md={2} >
        <div className="testimonial-quote group">
          <Box display={{ xs: 'none', sm: 'block'}}>
            <img
              src={require('../assets/404.svg')}
              alt='404'
              data-src={require("../assets/404.svg")}
              loading={'lazy'}
            />
          </Box>
        </div>
      </Grid>
      <Grid item sm={8} className="testimonial-quote group" >
      <div className="quote-container">
        <blockquote>
          <p>Not all those who wander are lost</p>
        </blockquote>
        <cite>
          J.R.R. Tolkien
          <br/>
          <span>The Fellowship of the Ring</span>
        </cite>
      </div>
      </Grid>
    </Grid>

  )
}
export default NotFoundView
